import { Avoider } from "./Avoider";
import gouch from "url:../assets/gouch.png";
import gouch2 from "url:../assets/gouch2.png";
import gouch3 from "url:../assets/gouch3.png";
import { FreeDrag } from "./cursor/draggables/FreeDrag";

export function GouchField(props: { onTarget: any }) {
    const count = 64;
    const index = Math.round(Math.random() * count);
    let elements = [];
    for (let i = 0; i < count; i++) {
        const w = 64;
        const h = 48;
        if (i == count - 1) {
            const x = Math.random() * (window.innerWidth - w - 8);
            const y = 512 + Math.random() * (window.innerHeight - h - 8 - 512);
            elements.push(<FreeDrag id={"gec101"} targetId="gec101-tar" onTarget={props.onTarget} key={i} x={x} y={y} z-index={9999}>
                <img id="gec101" src={gouch2} style={{ width: 64, height: 48 }} />
            </FreeDrag>);
        }
        else {
            const x = Math.random() * (window.innerWidth - w - 8);
            const y = Math.random() * (window.innerHeight - h - 8);
            elements.push(<Avoider key={i} x={x} y={y} w={w} h={h} r={Math.max(w, h)} content={<img src={gouch} style={{ width: w, height: h }} />} />);
        }
    }


    return (
        <div className='main-body'>
            <img id={"gec101-tar"} src={gouch3} style={{ color: '#000000', width: 66, height: 50, position: 'absolute', left: window.innerWidth / 2 - 65, top: window.innerHeight / 2 + 120 }} />
            {elements}
        </ div>
    );
}